import React from "react";
import { useDispatch } from "react-redux";
import { Box, Grid, Typography, CircularProgress, Backdrop } from "@mui/material";
import { downloadFileGet, InsertData } from "src/app-redux/common-actions";
import M3Logo from "src/assets/images/3M-Logo.png";
import AccuPay from "src/assets/images/AccuPay-Button.png";
import Betco from "src/assets/images/Betco-Button.png";
import BetcoLogoTransparent from "src/assets/images/betco-logo-transparent.png";
import DiverseyLogo from "src/assets/images/Diversey-Logo.png";
import LabCorp from "src/assets/images/LabCorp-Button.png";
import OfficeDepot from "src/assets/images/OfficeDepot-Button.png";
import PGLogo from "src/assets/images/PG-Logo.png";
import Staples from "src/assets/images/staples-Button.png";
import Sunbelt from "src/assets/images/Sunbelt-Button.png";
import SunbeltCouponCode from "src/assets/images/SunbeltCouponCode.png";
import TSS from "src/assets/images/TSS-Button.png";
import { useMyWinHeightContext } from "src/common/utils/getWindowDimensions";
import CommonDataGridPage from "src/components/CommonDataGridPage/CommonDataGridPage";
import Heading from "./Heading";
import { useStyles } from "./styles";

export default function SupplyPartnersList() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [loader, setLoader] = React.useState(false);
  const openSite = (url: string) => {
    SaveSupplyPartnerTracking(url);
    const win = window.open(url, "_blank");
    win?.focus();
  };
  const downloadDocument = async (documentName: string) => {
    setLoader(true);
    await dispatch(downloadFileGet(`download-supply-partner-document/${documentName}`));
    setLoader(false);
  };
  const SaveSupplyPartnerTracking = async (url: string) => {
    await dispatch(InsertData("create-supply_partner_link_tracking", { url: url }));
  };
  const { winHeight } = useMyWinHeightContext();
  const gridMaxHeight = winHeight - 200;
  return (
    <>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <CommonDataGridPage
        module={"Supply Partners"}
        heading={"Supply Partners"}
        linkTo="supply-partners"
        pageTitle="TFG | Portal | Supply Partners"
      >
        <Box style={{ height: gridMaxHeight, overflowY: "auto", marginBottom: 12 }}>
          <Grid direction="row">
            <Grid container direction="row">
              <Heading heading="Chemicals & Consumables" />
              <Grid item xs={12} md={6}>
                <Box
                  textAlign={"center"}
                  onClick={() => openSite("https://go.staples.com/natjan.html")}
                >
                  <img src={Staples} alt="img" width={400} className={classes.logoLink} />
                </Box>
                <Box
                  color="secondary"
                  textAlign={"center"}
                  onClick={() => openSite("https://go.staples.com/natjan.html")}
                >
                  <Typography className={classes.link}>
                    Add ship to address and program details
                  </Typography>
                </Box>
                <Box textAlign={"center"} display={"flex"} justifyContent="center" mt={2}>
                  <Box ml={1}>
                    <img src={PGLogo} alt="img" width={50} />
                  </Box>
                  <Box ml={1}>
                    <img src={DiverseyLogo} alt="img" width={90} />
                  </Box>
                  <Box ml={1}>
                    <img src={M3Logo} alt="img" width={70} />
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box
                  textAlign={"center"}
                  onClick={() => openSite("https://community.officedepot.com/GPOHome?id=75268026")}
                >
                  <img src={OfficeDepot} alt="img" width={400} className={classes.logoLink} />
                </Box>
                <Box
                  color="secondary"
                  textAlign={"center"}
                  onClick={() => downloadDocument("njsuserguide")}
                >
                  <Typography className={classes.link}>Ordering Instructions</Typography>
                </Box>
                <Box textAlign={"center"} display={"flex"} justifyContent="center" mt={2}>
                  <Box ml={1}>
                    <img src={BetcoLogoTransparent} alt="img" width={160} />
                  </Box>
                  <Box ml={1}>
                    <img src={M3Logo} alt="img" width={70} />
                  </Box>
                </Box>
              </Grid>
            </Grid>
            <Grid container direction="row">
              <Heading heading="Equipment" />
              <Grid item xs={12} md={6}>
                <Box
                  textAlign={"center"}
                  onClick={() =>
                    openSite(
                      "https://portal.natjan.com/userhome/VendorAccess/SupplyPartners/3a.BetcoEquipmentDetails.pdf"
                    )
                  }
                >
                  <img src={Betco} alt="img" width={400} className={classes.logoLink} />
                </Box>
                <Box
                  color="secondary"
                  textAlign={"center"}
                  onClick={() =>
                    openSite(
                      "https://na3.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=b2ea039a-6f2f-41f9-9e31-0012f22dd7c4"
                    )
                  }
                >
                  <Typography className={classes.link}>Order Form</Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box
                  textAlign={"center"}
                  position="relative"
                  onClick={() => openSite("https://www.sunbeltrentals.com/")}
                >
                  <img
                    src={Sunbelt}
                    alt="img"
                    width={400}
                    className={classes.logoLink}
                    style={{
                      position: "relative",
                    }}
                  />

                  <img
                    src={SunbeltCouponCode}
                    alt="img"
                    width={120}
                    style={{
                      position: "absolute",
                      top: "32px",
                      right: "120px",
                    }}
                  />
                </Box>
                <Box
                  color="secondary"
                  textAlign={"center"}
                  onClick={() => downloadDocument("sunbeltvendorportal")}
                >
                  <Typography className={classes.link}>Partnership Highlights</Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box
                  textAlign={"center"}
                  onClick={() =>
                    openSite(
                      "https://na3.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=05360c5b-953b-41d0-a4b6-80ae09e31fd7"
                    )
                  }
                >
                  <img src={TSS} alt="img" width={400} className={classes.logoLink} />
                </Box>
                <Box
                  color="secondary"
                  textAlign={"center"}
                  onClick={() =>
                    openSite(
                      "https://na3.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=05360c5b-953b-41d0-a4b6-80ae09e31fd7"
                    )
                  }
                >
                  <Typography className={classes.link}>Request Information</Typography>
                </Box>
              </Grid>
            </Grid>
            <Grid container direction="row">
              <Heading heading="For Your Business" />
              <Grid item xs={12} md={6}>
                <Box textAlign={"center"} onClick={() => openSite("https://www.labcorp.com/")}>
                  <img src={LabCorp} alt="img" width={400} className={classes.logoLink} />
                </Box>
                <Box
                  color="secondary"
                  textAlign={"center"}
                  onClick={() => downloadDocument("supplypartnerlabcorp")}
                >
                  <Typography className={classes.link}>Account Setup</Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box
                  textAlign={"center"}
                  onClick={() => openSite("https://www.accupay.net/accupay-njs")}
                >
                  <img src={AccuPay} alt="img" width={400} className={classes.logoLink} />
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </CommonDataGridPage>
    </>
  );
}
